const delay = (ms = 50) => new Promise((resolve) => setTimeout(resolve, ms));

export const submitEnquiry = async (payload) => {
  await delay();
  
  const id = Math.random().toString(36).substring(2, 9) + '-' + Date.now();
  const newEnquiry = {
    id,
    fullName: payload.fullName || "",
    company: payload.company || "",
    email: payload.email || "",
    phone: payload.phone || "",
    interest: payload.interest || "",
    message: payload.message || "",
    status: "new",
    submittedAt: new Date().toISOString()
  };
  
  const enquiries = JSON.parse(localStorage.getItem("admin_enquiries") || "[]");
  enquiries.unshift(newEnquiry);
  localStorage.setItem("admin_enquiries", JSON.stringify(enquiries));
  
  return { success: true, enquiry: newEnquiry };
};
